import { useState } from "react";
import { useSearchParams } from "next/navigation";
import { StickerPreview } from "@/components/sticker/StickerPreview";
import { StickerCustomizer } from "@/components/sticker/StickerCustomizer";
import { StickerConfig } from "@/lib/sticker";
import { I18nProvider } from "@/lib/i18n/context";
import { LanguageSwitch } from "@/components/common/LanguageSwitch";
import { useStickerMode } from "@/hooks/sticker/useStickerMode";
import { CanvasLayout } from "@/components/layout/CanvasLayout";

export const App = () => {
  const searchParams = useSearchParams();
  const [model, setModel] = useState(searchParams.get("item") || "lighter");
  const [stickerConfig, setStickerConfig] = useState<StickerConfig>({
    image: null,
    shape: "rectangle",
    size: { width: 65, height: 65, radius: 10, offset: 5 },
    material: "glossy",
    unit: "mm",
  });
  const stickerMode = useStickerMode();

  return (
    <I18nProvider>
      <CanvasLayout>
        <CanvasLayout.Main>
          <StickerPreview
            selectedModel={model}
            stickerConfig={stickerConfig}
            stickerMode={stickerMode}
          />
        </CanvasLayout.Main>
        <CanvasLayout.Panel>
          <StickerCustomizer
            stickerConfig={stickerConfig}
            setStickerConfig={setStickerConfig}
            selectedModel={model}
            setSelectedModel={setModel}
            stickerMode={stickerMode.mode}
          />
        </CanvasLayout.Panel>
      </CanvasLayout>
      <LanguageSwitch />
    </I18nProvider>
  );
};
